import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { VerifySceneEnum, VerifyStageEnum } from '@/shared/verify-credit-controller/types';
import { getPresentationConfig } from '@/shared/verify-credit-controller';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';
import ActivityRule from '@/components/activity-rule/index.vue';
import store from '@/store';
import { customSceneUIControls } from '../../const';

import style from './index.module.scss';

@Component({
  name: 'CreditFlowHeader',
})
export default class CreditFlowHeader extends Vue {
  @Prop(String) readonly verifyScene!: VerifySceneEnum;

  @Prop(String) readonly customName!: string;

  @Prop(Boolean) readonly showLoanTitle!: boolean;

  // 响应式最高额度文案
  private maxQuotaText = useMaxQuotaText();

  private get singleHeaderSecurity() {
    return customSceneUIControls.getIsSingleHeaderSecurity(this.verifyScene);
  }

  private get titleLatterPartText() {
    const { idCardActivityTitle, isLoadingActivityConfig } = store.state.verifyCredit;
    const text = idCardActivityTitle || getPresentationConfig()[VerifyStageEnum.ID_CARD]?.title || `最高可借${this.maxQuotaText.value}`;
    /** 配置读取时，展示"空"避免元素闪烁 */
    return isLoadingActivityConfig ? '' : text;
  }

  private render() {
    return (
      <div class={[style.creditFlowHeader]}>
        {this.singleHeaderSecurity
          ? null
          : (
            <div class={style.creditTitle}>
              <span>{this.showLoanTitle ? '进行身份认证' : `完成${this.customName || '身份认证'}`}</span>
              <span class={[style.highlightText]}>{this.showLoanTitle ? '享最快30秒放款' : this.titleLatterPartText}</span>
              <ActivityRule className={style.ruleWrapper} />
            </div>
          )
        }
        {
          this.singleHeaderSecurity
            ? (
              <div class={[style.headerSecurity, style.singleHeaderSecurity]}>
                <span class={style.safeIcon} />
                <span>哈啰承诺信息安全加密，</span>
                <span class={style.stressText}>严格保障你的信息安全</span>
              </div>
            )
            : (
              <div class={style.headerSecurity}>
                <span class={style.safeIcon} />
                <span >哈啰承诺信息安全加密，严格保障你的信息安全</span>
              </div>
            )
        }
      </div>
    );
  }
}
